import * as tslib_1 from "tslib";
import { MatDialog } from '@angular/material/dialog';
import { MaintenancesApi } from '@api/maintenances/maintenances.api';
import { AuthenticationService } from '@core/authentication/authentication.service';
import { FuseProgressBarService } from '@fuse/components/progress-bar/progress-bar.service';
import { DialogEditMaintenanceComponent } from 'app/main/maintenances/dialogs/dialog-edit-maintenance/dialog-maintenances.component';
var TabGeneralComponent = /** @class */ (function () {
    function TabGeneralComponent(matDialog, fuseProgressBarService, authenticationService, maintenancesApi) {
        this.matDialog = matDialog;
        this.fuseProgressBarService = fuseProgressBarService;
        this.authenticationService = authenticationService;
        this.maintenancesApi = maintenancesApi;
        this.hasEditMaintenancePermission = this.authenticationService.hasPermission('maintenances-edit');
        this.hasLabelViewPermission = this.authenticationService.hasPermission('labels-list');
    }
    TabGeneralComponent.prototype.editDialog = function (maintenance, isViewMode) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.fuseProgressBarService.show();
                        return [4 /*yield*/, this.maintenancesApi.searchOne(this.quotation.maintenance.id).toPromise()];
                    case 1:
                        maintenance = _a.sent();
                        this.fuseProgressBarService.hide();
                        return [4 /*yield*/, this.matDialog.open(DialogEditMaintenanceComponent, {
                                panelClass: 'dialog-edit-maintenance',
                                data: {
                                    maintenance: maintenance,
                                    isViewMode: isViewMode
                                }
                            })
                                .afterClosed()
                                .toPromise()];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    return TabGeneralComponent;
}());
export { TabGeneralComponent };
